<template>
   <el-tabs type="border-card" :v-model="1">
    <el-tab-pane label="用户列表">
      <el-form :inline="true" :model="userForm" class="demo-form-inline">
        <el-form-item label="注册时间">
          <el-date-picker
            v-model="userForm.createDate"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="用户名称">
          <el-input v-model.trim="userForm.moblie" placeholder="用户名称"></el-input>
        </el-form-item>
        <el-form-item label="关联用户">
          <el-checkbox v-model="userForm.isBelong"></el-checkbox>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="mini" @click="onSubmit" icon="el-icon-search">查询</el-button>
        </el-form-item>
      </el-form>
      <div style="margin-top:10px;">
        <el-table
        size = "small"
          :data="data"
          :row-class-name="tableRowName"
          @cell-dblclick="mainTabClick"
          border>
          <el-table-column
            prop="id"
            label="ID编号"
            width="100">
          </el-table-column>
          <el-table-column
            prop="moblie"
            show-overflow-tooltip
            label="用户名">
          </el-table-column>
          <el-table-column
            prop="bdSource"
            show-overflow-tooltip
            label="用户来源">
          </el-table-column>
          <el-table-column prop="linkUserName" label="接待客服" show-overflow-tooltip>
            <template scope="scope" >
              <span v-if="scope.row.index === cellData.tabMainIndex && cellData.tabMainLabel === '接待客服' && roleId == 1">
                <el-select v-model="cellData.linkUserId" placeholder="客服人员" @change="handleLinkUserEdit(scope.row)">
                  <el-option
                    v-for="item in systemUserData"
                    :key="item.id"
                    :label="item.userName"
                    :value="item.id">
                  </el-option>
                </el-select>
              </span>
              <template v-else>
                <span>{{scope.row.linkUserName}}</span>
              </template>
            </template>
          </el-table-column>
          <el-table-column
            prop="createDate"
            label="创建时间">
          </el-table-column>
          <el-table-column
          fixed="right"
          label="操作">
          <template slot-scope="scope">
            <el-button
              size="mini"
              v-if="scope.row.linkUserId == null"
              @click="linkUser(scope.row)">客服接待</el-button>
          </template>
        </el-table-column>
        </el-table>
      </div>
      <pagination :pagination="pagination" v-on:paginationClick="queryPagination"></pagination>
    </el-tab-pane>
   </el-tabs>
</template>
<script>
import pagination from "../../common/util/pagination";
export default {
  data() {
    return {
      data: [],
      systemUserData: [],
      systemUserForm: {
        token: this.user.getToken(),
        pageSize: 20,
        pageNum: 1,
        pageTotal: 0
      },
      userForm: {
        mobile: '',
        isBelong: false,
        createDate: [],
        token: this.user.getToken()
      },
      cellData: {
        tabMainIndex: '',
        tabMainLabel: '',
        linkUserId: ''
      },
      roleId: this.user.getUserData().roleId,
      pagination: {
        pageSize: 10,
        pageNum: 1,
        pageTotal: 0
      }
    };
  },
  components: {
    pagination
  },
  mounted: function() {
    this.getUserInfoList()
    this.getSystemUserList()
  },
  methods: {
    tableRowName({row, rowIndex}) {
      row.index = rowIndex
    },
    mainTabClick: function(row, column, cell, event) {
      this.cellData.tabMainIndex = row.index
      this.cellData.tabMainLabel = column.label
      this.cellData.linkUserId = row.linkUserId
    },
    getSystemUserList: function() {
      // 初始化默认加载菜单
      this.http.post(
        '/systemUser/list', 
        this.systemUserForm, res => {
          if (res.success) {
            // 返回正确的处理
            this.systemUserData = res.datas.data
          } else {
            // 返回错误的处理
            this.$message.error(res.message)
          }
      });
    },
    getUserInfoList: function() {
      this.optionItem = this.common.extend(this.userForm, this.pagination)
      // 初始化默认加载菜单
      this.http.post(
        '/user/list', 
        this.optionItem, res => {
          if (res.success) {
            // 返回正确的处理
            this.data = res.datas.data
            this.pagination.pageSize = res.datas.page.pageSize
            this.pagination.pageNum = res.datas.page.pageNum
            this.pagination.pageTotal = res.datas.page.pageCount
          } else {
            // 返回错误的处理
            this.$message.error(res.message)
          }
      });
    },
    onSubmit: function() {
      this.getUserInfoList()
    },
    queryPagination: function(currPage) {
      this.pagination.pageNum = currPage
      this.getUserInfoList()
    },
    linkUser: function(val) {
      // 判断该订单下是否存在需要发货的字订单
      this.http.post(
      '/user/link/customer', 
      {
        id: val.id,
        token: this.user.getToken()
      }, res => {
        if (res.success) {
          // 返回正确的处理
          this.getUserInfoList();
        } else {
          // 返回错误的处理
          this.$message.error(res.message)
        }
      });
    },
    handleLinkUserEdit: function(row) {
      if (this.cellData.linkUserId != row.linkUserId) {
        this.http.post(
          '/user/update/link/customer', 
          {
            id: row.id,
            systemUserId: this.cellData.linkUserId,
            token: this.user.getToken()
          }, res => {
            if (res.success) {
              this.cellData.tabMainIndex = null
              this.cellData.tabMainLabel = '' 
              this.cellData.linkUserId = '' 
              // 返回正确的处理
              this.getUserInfoList();
            } else {
              // 返回错误的处理
              this.$message.error(res.message)
            }
          });
      }else {
        this.cellData.tabMainIndex = null
        this.cellData.tabClickLabel = '' 
        this.cellData.linkUserId = row.linkUserId
      }
    },
  }
};
</script>


<style>
.el-table .warning-row {
  background: oldlace;
}

.el-table .success-row {
  background: #f0f9eb;
}
</style>


// WEBPACK FOOTER //
// src/components/views/user/onlineUserList.vue